// MenuBar.js
import React from "react";
import MenuLogo from "./MenuLogo.js";
import MenuItem from "./MenuItem.js";
import MenuSearch from "./MenuSearch.js";

interface MenuBarProps {
  className?: string;
}

const MenuBar: React.FC<MenuBarProps> = ({ className }) => {
  return (
    <nav className={className}>
      <div className="@container mx-4 flex max-h-10 items-stretch justify-between sm:mx-auto sm:max-h-max sm:justify-around">
        <MenuLogo className="py-2.5 text-meteoblue-500" />
        <div className="flex space-x-15">
          <div className="hidden space-x-15 sm:flex">
            <MenuItem label="MÉTÉO" href="#" />
            <MenuItem label="CARTES" href="#" />
            <MenuItem label="NOUVELLES" href="#" />
            <MenuItem label="VIDÉOS" href="#" />
          </div>
          <MenuSearch />
        </div>
      </div>
    </nav>
  );
};

export default MenuBar;
